import Box from '@mui/material/Box';
import React from 'react';
import SimFeaturedServiceSlider from 'components/SimFeaturedServiceSlider';
import { SimTypography } from 'components/SimTypography';
import { useTheme } from '@mui/material/styles';

const FeaturedServiceSlider = () => {
	const theme = useTheme();

	return (
		<Box>
			<Box marginBottom={4}>
				<SimTypography
					variant='h3'
					align={'center'}
					data-aos={'fade-up'}
					sx={{
						fontWeight: 700
					}}>
					Featured Services
				</SimTypography>

				<SimTypography variant='h6' align={'center'} color={theme.palette.text.primary} data-aos={'fade-up'}>
					What can we help you with?
				</SimTypography>

				<br />

				<SimTypography align={'center'} color={'text.secondary'} data-aos={'fade-up'}>
					<Box component='span' color={theme.palette.primary.main}>
						Essentials -
					</Box>{' '}
					at home or in facility screening{' '}
					<Box component='span' fontStyle={'italic'}>
						(autism, behavior & development)
					</Box>{' '}
					and therapies{' '}
					<Box component='span' fontStyle={'italic'}>
						{' '}
						(ABA, Feeding, Speech & Occupational)
					</Box>{' '}
					for children under the age of ten.
				</SimTypography>

				<br />

				<SimTypography align={'center'} color={'text.secondary'} data-aos={'fade-up'}>
					<Box component='span' color={theme.palette.primary.main}>
						ParentEd -
					</Box>{' '}
					delivered by leading experts, offers personalized educational, and emotional support resources to
					parents and care givers.
				</SimTypography>

				{/*
				<Box
					display='flex'
					flexDirection={{ xs: 'column', sm: 'row' }}
					alignItems={{ xs: 'stretched', sm: 'flex-start' }}
					justifyContent={'center'}
					marginTop={2}
				></Box>
				*/}
			</Box>

			<SimFeaturedServiceSlider />
		</Box>
	);
};

export { FeaturedServiceSlider };
